import { getCurrentInstance } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';
import type { Router } from 'vue-router';

const TWS_MODULE_PREFIX = 'tws://forecast_trader2';

interface OpenUrlOptions {
  target?: '_blank' | '_self';
  external?: boolean;
}

export function useNavigation() {
  const router = getCurrentInstance()?.appContext.config.globalProperties.$router as Router | undefined;
  const isWeb = () => app.option?.clientPlatform === 'web' || app.option?.platform === 'web';

  const openUrl = (url: string, options?: OpenUrlOptions) => {
    if (!isWeb() || !router) {
      app.send({ action: 'url-open', data: { url, target: options?.target, external: options?.external } });
      return;
    }
    if (url.startsWith(TWS_MODULE_PREFIX)) {
      const routePath = url.slice(TWS_MODULE_PREFIX.length) || '/';
      const resolved = router.resolve(routePath);
      if (resolved.matched.length > 0) {
        router.push(routePath).catch((e) => console.error('router.push failed', e));
      } else {
        window.location.hash = '#' + routePath;
      }
    } else if (url.startsWith('tws://')) {
      app.send({ action: 'url-open', data: { url, target: options?.target, external: options?.external } });
    } else if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, options?.target ?? '_blank');
    } else {
      router.push(url);
    }
  };

  const openSearch = () => {
    if (!isWeb()) {
      openUrl(`${TWS_MODULE_PREFIX}/search?page=leaf`);
    } else if (router?.hasRoute('Search')) {
      router.push({ name: 'Search' }).catch((error) => console.error('router.push failed', error));
    } else {
      openUrl(`${TWS_MODULE_PREFIX}/search`);
    }
  };

  return { openUrl, openSearch };
}
// last modified by AI tools on 2026-10-09
